// Sprint 11b — Project chip for the composer toolbar.
//
// Read-only chip showing which project the current agent belongs to.
// Derives the display name from the agent's projectId; falls back to
// extracting the project slug from agent.workdir (D-006 layout).

import type { Agent } from '../types';
import { Icon } from './atoms/Icon';

function deriveProjectLabel(agent: Agent): string | null {
  if (agent.projectId && agent.projectId !== 'default') {
    return agent.projectId;
  }
  const workdir = agent.workdir || '';
  if (!workdir) return null;
  const match = workdir.match(/\/projects\/([^/]+)/);
  if (match?.[1]) return match[1];
  const parts = workdir.replace(/\/+$/, '').split('/').filter(Boolean);
  return parts[parts.length - 1] ?? null;
}

export function ProjectChip({ agent }: { agent: Agent }) {
  const label = deriveProjectLabel(agent);
  if (!label) return null;

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-secondary text-secondary-foreground text-caption select-none"
      data-testid="composer-project-chip"
      title={label}
    >
      <Icon name="Folder" size={12} className="shrink-0 text-muted-foreground" />
      <span className="truncate max-w-[80px]">{label}</span>
    </span>
  );
}
